import React from 'react';
import SelectLanguage from '@apricityhealth/web-common-lib/components/SelectLanguage';
import SelectPlan from '@apricityhealth/web-common-lib/components/SelectPlan';
import SelectText from '@apricityhealth/web-common-lib/components/SelectText';
import { loadText } from '@apricityhealth/web-common-lib/utils/Services';
import { Button, IconButton, TextField } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

export class TextOverrides extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            org: props.org,
            selectedPlanId: null
        }
    }

    render() {
        const { appContext, onChange } = this.props;
        const { org, selectedPlanId } = this.state;

        let textOverrides = [];
        if ( org.config['textOverrides'] ) {
            try {
                textOverrides = JSON.parse( org.config['textOverrides'] || "[]" )
            } catch(err) {
                console.error("textOverrides parse error:", err );
                textOverrides = [];
            }
        }

        const plans = Array.isArray(org.planIds) ? org.planIds : [];
        const orgPlanIds = plans.map((p) => p?.planId).filter(Boolean);
        const defaultPlanId = plans.find((p) => p?.default)?.planId
            || plans[0]?.planId
            || null;
        const activePlanId = selectedPlanId || defaultPlanId;

        const onUpdateOrg = (org) => {
            if ( textOverrides.length > 0) {
                org.config['textOverrides'] = JSON.stringify(textOverrides);
            } else {
                delete org.config['textOverrides'];
            }
            this.setState({org}, () => {
                if ( onChange ) onChange( org )
            })
        }

        const populateOverrideText = (override) => {
            console.log("populateOverrideText:", override, activePlanId );
            if (!override.textId || !activePlanId) return;
            loadText(appContext, {
                textId: override.textId,
                language: override.language || 'en-us',
                planId: activePlanId,
                dependencies: true
            }).then((results) => {
                console.log("populateOverrideText results:", results);
                const sourceText = results?.[0]?.text;
                if (sourceText) {
                    override.text = sourceText;
                    onUpdateOrg( org );
                } else {
                    console.warn("populateOverrideText: no text returned for", { textId: override.textId, language: override.language, planId: activePlanId });
                }
            }).catch((err) => {
                console.error("populateOverrideText error:", err);
            });
        }

        return <div>
            <SelectPlan
                appContext={appContext}
                label='Plan'
                planId={activePlanId || ''}
                planIds={orgPlanIds}
                hideProtected={false}
                hideEditable={false}
                onChange={(plan) => {
                    this.setState({ selectedPlanId: plan?.planId || null });
                }}
            />
            <table>
                <tbody>
                {textOverrides.map((override, i) => {
                    return <tr key={i}>
                        <td valign='top'>
                            <IconButton style={{margin: 5}} onClick={() => {
                                textOverrides.splice(i, 1);
                                onUpdateOrg( org );
                            }}><DeleteIcon /></IconButton>
                        </td>
                        <td valign='top'>
                            <SelectText
                                appContext={appContext}
                                planId={activePlanId}
                                label='Text ID'
                                style={{ margin: 5, width: 400 }}
                                textId={override.textId}
                                onChange={(text) => {
                                    console.log("SelectText.onChange:", text );
                                    override.textId = text?.textId || '';
                                    if (text?.text) override.text = text.text;
                                    onUpdateOrg( org );
                                }}
                            />
                            <SelectLanguage appContext={appContext} language={override.language} onChange={(language) => {
                                override.language = language;
                                onUpdateOrg( org );
                                populateOverrideText( override );
                            }} />
                        </td>
                        <td valign='top'>
                            <TextField variant='outlined' style={{margin: 5, width: 600}} multiline={true} minRows={5} maxRows={5} label='Text' value={override.text} onChange={(e) => {
                                override.text = e.target.value;
                                onUpdateOrg( org );
                            }} />
                        </td>
                    </tr>
                })}
                </tbody>
            </table>
            <br />
            <Button size='small' startIcon={<AddIcon />} style={{ margin: 5 }} onClick={(e) => {
                textOverrides.push( { textId: '', text: '', language: 'en-us' } );
                onUpdateOrg( org );
            }}>Add Override</Button>
        </div>
    }
}